<template>
    <div class="modal fade" :id="id" role="dialog" tabindex="-1">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-header bg-secondary text-white">
                    <h6 class="modal-title">
                        <i class="far fa-file-export fa-fw me-2"></i>Esporta dati
                    </h6>
                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body text-center py-3">
                    <p class="text-muted small mb-3">Scegli il formato di esportazione</p>
                    <button class="btn btn-success me-2" @click.prevent="scegli(2)">
                        <i class="far fa-file-excel fa-fw me-1"></i>Excel
                    </button>
                    <button class="btn btn-danger" @click.prevent="scegli(1)">
                        <i class="far fa-file-pdf fa-fw me-1"></i>PDF
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PopUpEsportazione',
    props: {
        id: { type: String, default: 'popUpEsportazione' }
    },
    data() {
        return { filters: global.filters }
    },
    methods: {
        scegli(formato) {
            this.$emit('esporta', formato);
            this.filters.closePopUp(this.id);
        }
    }
}
</script>
